import Preloader from '../components/Preloader';
import Navigation from '../components/Navigation';
import usePage from '../framework/hooks/usePageHook';
import Footer from '../components/Footer';
import CaseSlider from '../components/case/CaseSlider';
import Brands from '../components/Brands';
import TeamSlider from '../components/team/TeamSlider';
import WhatWeDo from "../components/WhatWeDo";
import About from "../components/About";
import Header from "../components/Header";

export default function HomePage({ page }) {
    // const pageObj = usePage(page.id);

    if (!page) return <Preloader />;

    return (
        <>
            <Navigation page={page} />
            <Header page={page} />
            <About page={page} />
            <WhatWeDo />
            <CaseSlider />
            <Brands />
            <TeamSlider />
            <Footer />
        </>
    );
}
